import { Checkbox, CircularProgress, FormControlLabel, TextField } from '@mui/material';

import { Button } from '@/components/Button';

import { useLoginPageStore } from '../model/context';

export interface StepItem {
  title: string;
  content: React.ReactNode;
}

import s from '../LegacyLoginPage.module.scss';

export const useLoginSteps = (): StepItem[] => {
  const {
    callbackUrl,
    setCallbackUrl: onChangeCallbackUrl,
    handleOpenYandexAuth: onAuthClick,
    handleSubmit: onTokenSave,
    isLoading,
    openInNewWindow,
    toggleOpenInNewWindow,
    goToPreviousStep,
  } = useLoginPageStore();

  return [
    {
      title: 'Вход в Яндекс.Трекер',
      content: (
        <>
          <p>Нажмите кнопку ниже, чтобы открыть страницу авторизации Яндекс.Трекера</p>
          <FormControlLabel
            control={
              <Checkbox
                checked={openInNewWindow}
                onChange={toggleOpenInNewWindow}
                sx={{
                  color: 'var(--primary-color)',
                  '&.Mui-checked': {
                    color: 'var(--primary-color)',
                  },
                }}
              />
            }
            label="Открыть в новом окне"
            sx={{
              color: 'var(--primary-color)',
              '& .MuiFormControlLabel-label': {
                fontFamily: 'Montserrat',
              },
            }}
          />
          <Button onClick={onAuthClick}>Авторизация</Button>
        </>
      ),
    },
    {
      title: 'Получение токена',
      content: (
        <>
          <p>
            После успешной авторизации скопируйте URL из адресной строки браузера и вставьте его в
            поле ниже
          </p>

          <div>
            <p>Токен</p>
            <TextField
              fullWidth
              placeholder="http://127.0.0.1:6179?token=..."
              value={callbackUrl}
              onChange={(e) => onChangeCallbackUrl(e.target.value)}
              multiline
              rows={3}
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: '6px',
                  marginTop: 1,
                },
                '& .MuiInputBase-input': {
                  fontFamily: 'Montserrat',
                  fontSize: 16,
                  color: 'var(--primary-color)',
                },
              }}
            />
          </div>
          <div className={s.login__buttons}>
            <Button onClick={onTokenSave} disabled={isLoading || !callbackUrl}>
              {isLoading ? <CircularProgress size={12} /> : 'Войти'}
            </Button>
            <Button variant="text" onClick={goToPreviousStep}>
              {openInNewWindow ? 'Окно не открылось' : 'Вкладка не открылась'}
            </Button>
          </div>
        </>
      ),
    },
    {
      title: 'Вход в систему',
      content: <p>Токен проверяется, происходит вход в систему...</p>,
    },
  ];
};
